import { AxiosResponse } from 'axios'
import fileDownload from 'js-file-download'

import { date } from 'configuration/dayjs'
import message from 'utilities/message'

export const SYNC_CSV_RECORD_LIMIT = 500

const downloadFile = (
    data: string | ArrayBuffer | ArrayBufferView | Blob,
    filename: string
): void => fileDownload(data, filename)

const downloadCsvSuccessMessage = (recordCount: string): void => {
    let msg = 'CSV download completed successfully.'
    if (parseInt(recordCount, 10) === SYNC_CSV_RECORD_LIMIT) {
        msg += ` This download has been limited to the first ${SYNC_CSV_RECORD_LIMIT} records.`
    }
    message.success(msg)
}

export const downloadCsv = (
    { data, headers }: AxiosResponse<any, any>,
    filename_identifier: string
): void => {
    downloadFile(
        data,
        `cobalt-${filename_identifier}-${date().format('YYYY-MM-DD')}.csv`
    )
    downloadCsvSuccessMessage(headers['x-dsi-csv-record-count'])
}

// Triggers a download from a remote URL without navigating the parent window
// or flashing a new tab. The URL must respond with `Content-Disposition:
// attachment` (S3 presigned URLs do); the browser intercepts the response and
// starts the download while the iframe stays empty.
const IFRAME_CLEANUP_DELAY_MS = 60_000
export const triggerRemoteDownload = (url: string): void => {
    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.src = url
    document.body.appendChild(iframe)
    window.setTimeout(() => iframe.remove(), IFRAME_CLEANUP_DELAY_MS)
}
